const AUTH_TYPE = Object.freeze({
  web: 'web',
  firebase: 'firebase',
});

export default AUTH_TYPE;
